<template>
  <div v-loading.body="loading">
    <header-tabs :active="$route.path"></header-tabs>
    <el-tabs
      v-model="tabActiveName"
      style="margin-top: 10px"
      type="card"
      @tab-click="handleClickTab"
    >
      <el-tab-pane label="地址配置" :name="ADDRESS_SETTING">
        <div class="row" :gutter="20" align="middle">
          <el-button
            type="primary"
            style="margin-left: auto"
            @click="shippingVisible = true"
          >
            新增网点
          </el-button>
        </div>
        <el-row>
          <el-col style="border: 1px solid #ddd">
            <div style="margin-bottom: 0">
              <el-table
                v-if="resData"
                ref="multipleTable"
                v-loading="tableLoading"
                height="800"
                :data="resData.list"
                tooltip-effect="dark"
                style="width: 100%"
              >
                <el-table-column
                  align="center"
                  prop="shipping_company"
                  label="快递公司"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="express_account"
                  label="菜鸟账号"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="province"
                  label="省"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="city"
                  label="市"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="district"
                  label="区"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="detail"
                  label="详细地址"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="admin_name"
                  label="最后操作人员"
                ></el-table-column>

                <el-table-column
                  prop="shipping_sender_is_default"
                  label="是否默认"
                  show-overflow-tooltip
                  align="center"
                >
                  <template #default="scope">
                    <el-button
                      type="primary"
                      icon="el-icon-edit"
                      size="mini"
                      circle
                      @click="setDefault(scope.row)"
                    ></el-button>
                    <span>{{ scope.row.shipping_sender_is_default }}</span>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="shipping_sender_is_default"
                  label="退换货默认快递"
                  show-overflow-tooltip
                  align="center"
                >
                  <template #default="scope">
                    <el-button
                      type="primary"
                      icon="el-icon-edit"
                      size="mini"
                      circle
                      @click="setReturnDefault(scope.row)"
                    ></el-button>
                    <span>{{ getReturnDefaultText(scope.row) }}</span>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="warning"
                  label="是否开启预警值通知"
                  width="200"
                  align="center"
                >
                  <template #default="scope">
                    <el-switch
                      v-model="scope.row.is_warning"
                      active-value="1"
                      inactive-value="0"
                      @change="setWarningSwitch($event, scope.row)"
                    >
                    </el-switch>
                    <el-input-number
                      v-model="scope.row.warning_num"
                      style="width: 120px"
                      size="small"
                      :step="1"
                      :min="1"
                      :disabled="scope.row.is_warning === '0'"
                      @change="setWarningNum($event, scope.row)"
                    ></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <template #default="scope">
                    <el-button
                      type="text"
                      size="small"
                      @click="
                        beforeSetSender(
                          scope.row.cpcode,
                          scope.row.id,
                          scope.row.express_account_id,
                          2
                        )
                      "
                      >修改
                    </el-button>
                    <el-button
                      type="danger"
                      size="small"
                      :disabled="scope.row.is_default === IS_DEFAULT_YES"
                      @click="handleDeleteSender(scope)"
                      >删除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="顺丰快递配置" :name="SF_EXPRESS_SETTING">
        <div class="row" :gutter="20" align="middle">
          <el-button
            type="primary"
            style="margin-left: auto"
            @click="handleAddSfExpress"
          >
            新增
          </el-button>
        </div>
        <el-row>
          <el-col style="border: 1px solid #ddd">
            <div style="margin-bottom: 0">
              <el-table
                v-if="resSFData"
                ref="multipleTable"
                v-loading="tableLoading"
                height="800"
                :data="resSFData"
                tooltip-effect="dark"
              >
                <el-table-column
                  align="center"
                  prop="account"
                  label="网点号名称"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="weight_type_formal"
                  label="包裹预测重量"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="cust_id"
                  label="网点月结号"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="express_type_formal"
                  label="快递类型"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="province"
                  label="省"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="city"
                  label="市"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="district"
                  label="区"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="detail"
                  label="详细地址"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="sender_name"
                  label="发货人"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="sender_phone"
                  label="发货人电话"
                ></el-table-column>
                <el-table-column align="center" prop="" label="顾客编码">
                  <template #default="scope">
                    <el-button
                      type="primary"
                      icon="el-icon-edit"
                      size="mini"
                      circle
                      @click="showDialogAccountCode(scope.row)"
                    ></el-button>
                  </template>
                </el-table-column>
                <el-table-column
                  prop=""
                  label="校验码"
                  show-overflow-tooltip
                  align="center"
                >
                  <template #default="scope">
                    <el-button
                      type="primary"
                      icon="el-icon-edit"
                      size="mini"
                      circle
                      @click="showDialogAccountToken(scope.row)"
                    ></el-button>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="is_monthly"
                  label="是否月结"
                >
                  <template #default="scope">
                    <span>{{
                      scope.row.is_monthly === IS_MONTHLY_YES ? "是" : "否"
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="is_default"
                  label="是否默认"
                >
                  <template #default="scope">
                    <span>{{
                      scope.row.is_default === IS_DEFAULT_YES ? "是" : "否"
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="is_deleted"
                  label="是否启用"
                >
                  <template #default="scope">
                    <span>{{
                      scope.row.is_deleted === IS_DELETED_YES ? "禁用" : "启用"
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="is_qr_code"
                  label="是否打印二维码面单"
                >
                  <template #default="scope">
                    <span>{{
                      scope.row.is_qr_code === "1" ? "否" : "是"
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <template #default="scope">
                    <el-button
                      type="text"
                      size="small"
                      @click="handleEditSFExpress(scope.row)"
                    >
                      编辑
                    </el-button>
                    <el-button
                      type="danger"
                      size="small"
                      :disabled="scope.row.is_default === IS_DEFAULT_YES"
                      @click="handleDeleteSender(scope)"
                      >删除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="京东保价配置" :name="Jd_EXPRESS_SETTING">
        <div class="row" :gutter="20" align="middle">
          <el-button
            type="primary"
            style="margin-left: auto"
            :disabled="true"
            @click="handleAddJdExpress"
          >
            新增[暂未开放]
          </el-button>
        </div>
        <el-row>
          <el-col style="border: 1px solid #ddd">
            <div style="margin-bottom: 0">
              <el-table
                v-if="resJdData"
                ref="multipleTable"
                v-loading="tableLoading"
                height="800"
                :data="resJdData"
                tooltip-effect="dark"
              >
                <el-table-column
                  align="center"
                  prop="account"
                  label="网点号名称"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="cust_id"
                  label="月结号"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="detail"
                  label="发货地址"
                ></el-table-column>

                <el-table-column
                  prop="guarantee_value"
                  label="是否判断保价"
                  show-overflow-tooltip
                  align="center"
                  :formatter="stateGuaranteeType"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="guarantee_value_amount"
                  label="保价金额设置(元)"
                >
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <template #default="scope">
                    <el-button
                      type="text"
                      size="small"
                      @click="handleEditJdExpress(scope.row)"
                    >
                      编辑
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="请选择地址" :visible.sync="senderVisible">
      <el-form :model="form">
        <el-form-item>
          <el-radio
            v-for="(sender_value, sender_key) in senders"
            :key="sender_key"
            v-model="sender"
            :label="sender_key"
            style="margin: 0 auto"
          >
            {{ sender_value.province }},{{ sender_value.city }},{{
              sender_value.district
            }},{{ sender_value.detail }}
            <span style="color: #ff6297; font-size: 12px"
              >(网点名称:{{ sender_value.branchName }},网点编码:{{
                sender_value.branchCode
              }},剩余面单数:{{ sender_value.quantity }})</span
            ></el-radio
          >
          <br />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="senderVisible = false">取 消</el-button>
        <el-button type="primary" @click="setSender">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="请选择快递公司" :visible.sync="shippingVisible">
      <el-form :model="form">
        <el-form-item label="快递公司">
          <el-select
            v-model="form.cpcode"
            placeholder="请选择快递公司"
            @change="beforeSetSender('', 0, '')"
          >
            <el-option
              v-for="item in resData.shipping_company"
              :key="item.cniao"
              :label="item.shipping_company"
              :value="item.cniao"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="菜鸟/网点账号">
          <el-select
            v-model="form.express_account_id"
            placeholder="菜鸟/网点账号"
            @change="beforeSetSender('', 0, '')"
          >
            <el-option
              v-for="item in resData.account"
              :key="item.express_account_id"
              :label="item.account"
              :value="item.express_account_id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="shippingVisible = false">取 消</el-button>
        <el-button type="primary" @click="setSender">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="修改顾客编码"
      :visible.sync="showAccountCode"
      @close="handleResetAccountCode"
    >
      <el-input v-model="accountCode" placeholder="请输入顾客编码"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAccountCode = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmitAccountCode">
          确 定
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="修改校验码"
      :visible.sync="showAccountToken"
      @close="handleResetAccountToken"
    >
      <el-input v-model="accountToken" placeholder="请输入校验码"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAccountToken = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmitAccountToken">
          确 定
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="sfForm.id ? '修改顺丰快递配置' : '新增顺丰快递配置'"
      :visible.sync="showEditSFForm"
      @close="handleResetSFForm"
    >
      <el-form
        ref="sfForm"
        :model="sfForm"
        :rules="sfFormRules"
        label-width="120px"
      >
        <el-form-item label="网点号名称">
          <!--根据选择规则自动生成-->
          <div>{{ expressLocationName }}</div>
        </el-form-item>
        <el-form-item label="包裹预测重量" prop="weight_type" required>
          <el-select
            v-model="sfForm.weight_type"
            placeholder="请选择包裹预测重量"
            @change="checkHasDefaultTips"
          >
            <el-option
              v-for="item in weightTypeOption"
              :key="item.key"
              :label="item.name"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="网点月结号" prop="cust_id">
          <el-input
            v-model="sfForm.cust_id"
            placeholder="请输入网点月结号"
          ></el-input>
        </el-form-item>
        <el-form-item label="快递类型" prop="express_type" required>
          <el-select v-model="sfForm.express_type" placeholder="请选择快递类型">
            <el-option
              v-for="item in expressTypeOption"
              :key="item.express_type"
              :label="item.express_type_formal"
              :value="item.express_type"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发货地址省份" prop="province">
          <el-select v-model="sfForm.province" filterable @change="getCity">
            <el-option
              v-for="item in provinceOptions"
              :key="item.id"
              :value="item.name"
              :label="item.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="发货地址市" prop="city">
          <el-select
            v-model="sfForm.city"
            filterable
            :disabled="!sfForm.province"
            @change="getDistrict"
          >
            <el-option
              v-for="item in cityOptions"
              :key="item.id"
              :value="item.name"
              :label="item.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="发货地址区" prop="district">
          <el-select
            v-model="sfForm.district"
            filterable
            :disabled="!sfForm.city"
          >
            <el-option
              v-for="item in districtOptions"
              :key="item.id"
              :value="item.name"
              :label="item.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="发货详细地址" prop="detail">
          <el-input
            v-model="sfForm.detail"
            placeholder="请输入发货详细地址"
            maxlength="200"
            show-word-limit
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="发货人" prop="sender_name">
          <el-input
            v-model="sfForm.sender_name"
            placeholder="请输入发货人名字"
            maxlength="20"
            show-word-limit
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="发货人电话" prop="sender_phone">
          <el-input
            v-model="sfForm.sender_phone"
            placeholder="请输入发货电话"
            maxlength="20"
            show-word-limit
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="!sfForm.sender_id"
          prop="cust_code"
          label="顾客编码"
        >
          <el-input
            v-model="sfForm.cust_code"
            placeholder="请输入顾客编码"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="!sfForm.sender_id"
          prop="account_token"
          label="校验码"
        >
          <el-input
            v-model="sfForm.account_token"
            placeholder="请输入校验码"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否月结" prop="is_monthly" required>
          <el-select v-model="sfForm.is_monthly" placeholder="请选择是否月结">
            <el-option
              v-for="item in monthlyOption"
              :key="item.key"
              :label="item.name"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否默认" prop="is_default" required>
          <el-select
            v-model="sfForm.is_default"
            placeholder="请选择是否默认"
            @change="checkHasDefaultTips"
          >
            <el-option
              v-for="item in defaultOption"
              :key="item.key"
              :label="item.name"
              :value="item.key"
            ></el-option>
          </el-select>
          <div
            v-if="showHasDefaultTips"
            style="color: red; display: inline-block; margin-left: 10px"
          >
            包裹预测重量已经存在默认选项
          </div>
        </el-form-item>
        <el-form-item label="是否启用" prop="is_deleted" required>
          <el-select v-model="sfForm.is_deleted" placeholder="请选择是否启用">
            <el-option
              v-for="item in openOption"
              :key="item.key"
              :label="item.name"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否打印二维码面单" prop="is_qr_code" required>
          <el-select v-model="sfForm.is_qr_code" placeholder="请选择是否打印">
            <el-option
              v-for="item in printOptions"
              :key="item.key"
              :label="item.name"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showEditSFForm = false">取 消</el-button>
        <el-button
          type="primary"
          :loading="loadingSubmitSFForm"
          @click="handleSubmitSFForm"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="jdForm.id ? '修改京东快递配置' : '新增京东快递配置'"
      :visible.sync="showEditJdForm"
      @close="handleResetJdForm"
    >
      <el-form
        ref="jdForm"
        :model="jdForm"
        :rules="jdFormRules"
        label-width="140px"
      >
        <el-form-item label="网点号名称" prop="account">
          <el-input
            v-model="jdForm.account"
            placeholder="请输入网点号名称"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="月结号" prop="cust_id">
          <el-input
            v-model="jdForm.cust_id"
            placeholder="请输入月结号"
          ></el-input>
        </el-form-item>
        <el-form-item label="发货地址" prop="detail">
          <el-input
            v-model="jdForm.detail"
            placeholder="请输入发货地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否判断保价" prop="guarantee_value">
          <el-select
            v-model="jdForm.guarantee_value"
            placeholder="请选择是否保价"
          >
            <el-option
              v-for="item in guaranteeOption"
              :key="item.key"
              :label="item.name"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="保价金额设置(元)" prop="guarantee_value_amount">
          <el-input-number
            v-model="jdForm.guarantee_value_amount"
            :disabled="jdForm.guarantee_value === GUARANTEE_NO"
            :precision="2"
            :step="0.1"
            :min="0"
            :max="1000000"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showEditJdForm = false">取 消</el-button>
        <el-button
          type="primary"
          :loading="loadingSubmitJdForm"
          @click="handleSubmitJdForm"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import HeaderTabs from "./components/HeaderTabs.vue";
import * as warehouseConfigApi from "@/controller/warehouseConfig2278.js";
import { editShippingSenderJdConfig } from "../../controller/warehouseConfig2278"; // 3公斤以上
import { postDelSender } from "@/openapi/erp/wavePicking.js";

const ADDRESS_SETTING = "ADDRESS_SETTING";
const SF_EXPRESS_SETTING = "SF_EXPRESS_SETTING";
const Jd_EXPRESS_SETTING = "Jd_EXPRESS_SETTING";
const IS_MONTHLY_YES = "1";
const IS_MONTHLY_NO = "2";
const IS_DELETED_YES = "2";
const IS_DELETED_NO = "1";
const GUARANTEE_YES = "1";
const GUARANTEE_NO = "2";
const IS_DEFAULT_YES = "1";
const IS_DEFAULT_NO = "0";
const WEIGHT_TYPE_DEFAULT = "0"; // 默认不使用重量枚举
const WEIGHT_TYPE_ZERO_THREE = "1"; // 0-3公斤
const WEIGHT_TYPE_ABOVE_THREE = "2";
export default {
  components: { HeaderTabs },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
      vm.fetchSFData();
      vm.featchJdData();
      vm.getExpressType();
      vm.getStoreHouse();
    });
  },
  data() {
    return {
      IS_DEFAULT_YES,
      showHasDefaultTips: false, // 是否显示已有默认配置提示
      storehouse: "", // 所属仓库名
      loadingSubmitSFForm: false,
      loadingSubmitJdForm: false,
      monthlyOption: [
        { name: "是", key: IS_MONTHLY_YES },
        { name: "否", key: IS_MONTHLY_NO },
      ],
      defaultOption: [
        { name: "是", key: IS_DEFAULT_YES },
        { name: "否", key: IS_DEFAULT_NO },
      ],
      openOption: [
        { name: "启用", key: IS_DELETED_NO },
        { name: "禁用", key: IS_DELETED_YES },
      ],
      printOptions: [
        { name: "否", key: "1" },
        { name: "是", key: "2" },
      ],
      guaranteeOption: [
        { name: "是", key: GUARANTEE_YES },
        { name: "否", key: GUARANTEE_NO },
      ],
      weightTypeOption: [
        { name: "默认不使用重量枚举", key: WEIGHT_TYPE_DEFAULT },
        { name: "小于等于3kg", key: WEIGHT_TYPE_ZERO_THREE },
        { name: "大于3kg", key: WEIGHT_TYPE_ABOVE_THREE },
      ],
      expressTypeOption: [],
      WEIGHT_TYPE_DEFAULT,
      WEIGHT_TYPE_ZERO_THREE,
      WEIGHT_TYPE_ABOVE_THREE,
      showEditSFForm: false,
      showEditJdForm: false,
      sfForm: {
        sender_id: "", // 网点id
        weight_type: "", // 包裹预测重量枚举:{0:默认不使用重量枚举, 1:0-3公斤 , 2:3公斤以上}
        cust_id: "", // 网点月结号
        express_type: "", // 快递类型 231=陆运包裹,247=电商标快,111=顺丰干配
        detail: "", // 发货地址
        is_monthly: "", // 是否月结:{1:是,2:否}
        is_default: "", // 是否默认:{0:否,1:是}
        is_deleted: "", // 是否禁用:{1:否,2:是}
        account_token: "", // 校验码
        cust_code: "", // 顾客编码
        is_qr_code: "",
        province: "",
        city: "",
        district: "",
        sender_name: "",
        sender_phone: "",
      }, // 顺丰网点表单
      jdForm: {
        id: "", // 网点id
        account: "", // 网点号名称
        cust_id: "", // 网点月结号
        detail: "", // 发货地址
        guarantee_value: GUARANTEE_YES, // 是否保价:{1:是,2:否},默认为是
        guarantee_value_amount: 500.0, // 保价金额，单位元，保留两位小数
      },
      sfFormRules: {
        weight_type: [
          {
            required: true,
            message: "请选择包裹预测重量",
            trigger: "change",
          },
        ],
        cust_id: [
          {
            required: true,
            message: "请输入网点月结号",
            trigger: "blur",
          },
        ],
        express_type: [
          {
            required: true,
            message: "请选择快递类型",
            trigger: "change",
          },
        ],
        detail: [
          {
            required: true,
            message: "请输入发货地址",
            trigger: "blur",
          },
        ],
        cust_code: [
          {
            required: true,
            message: "请输入顾客编码",
            trigger: "blur",
          },
        ],
        account_token: [
          {
            required: true,
            message: "请输入校验码",
            trigger: "blur",
          },
        ],
        is_monthly: [
          {
            required: true,
            message: "请选择是否月结",
            trigger: "change",
          },
        ],
        is_default: [
          {
            required: true,
            message: "请选择是否默认",
            trigger: "change",
          },
        ],
        is_deleted: [
          {
            required: true,
            message: "请选择是否启用",
            trigger: "change",
          },
        ],
        is_qr_code: [
          {
            required: true,
            message: "请选择是否打印",
            trigger: "change",
          },
        ],
        province: [
          {
            required: true,
            message: "请选择发货地址省份",
            trigger: "change",
          },
        ],
        city: [
          {
            required: true,
            message: "请选择发货地址市区",
            trigger: "change",
          },
        ],
        district: [
          {
            required: true,
            message: "请选择发货地址区",
            trigger: "change",
          },
        ],
        sender_name: [
          {
            required: true,
            message: "请输入发货人名字",
            trigger: "blur",
          },
        ],
        sender_phone: [
          {
            required: true,
            message: "请输入发货人电话",
            trigger: "blur",
          },
        ],
      },
      jdFormRules: {
        account: [
          {
            required: true,
            message: "请输入网点号名称",
            trigger: "blur",
          },
        ],
        cust_id: [
          {
            required: true,
            message: "请输入网点月结号",
            trigger: "blur",
          },
        ],
        detail: [
          {
            required: true,
            message: "请输入发货地址",
            trigger: "blur",
          },
        ],
        guarantee_value: [
          {
            required: true,
            message: "请选择是否保价",
            trigger: "blur",
          },
        ],
        guarantee_value_amount: [
          {
            required: true,
            message: "请输入保价金额",
            trigger: "blur",
          },
        ],
      },
      currentSenderId: "", // 编辑中的网点id
      showAccountCode: false, // 显示编辑编码弹框
      showAccountToken: false, // 显示编辑校验码弹框
      accountCode: "", // 用户编码
      accountToken: "", // 用户校验码
      IS_MONTHLY_YES,
      IS_MONTHLY_NO,
      IS_DELETED_YES,
      IS_DELETED_NO,
      IS_DEFAULT_YES,
      IS_DEFAULT_NO,
      GUARANTEE_YES,
      GUARANTEE_NO,
      ADDRESS_SETTING,
      SF_EXPRESS_SETTING,
      Jd_EXPRESS_SETTING,
      tabActiveName: ADDRESS_SETTING,

      shippingVisible: false,
      resData: {
        list: [],
      },
      resSFData: [],
      resJdData: [],
      form: {
        cpcode: "",
        sender: "",
        express_account_id: "",
      },
      loading: false,
      tableLoading: false,
      url: "/erp/WavePicking/senderList",
      filterFold: false,
      supplyData: null,
      origin: 1,
      origins: [
        { origin_id: 1, origin_name: "广州" },
        { origin_id: 2, origin_name: "杭州" },
      ],
      senderVisible: false,
      senders: [],
      sender: "",
      cpcode: "",
      express_account_id: "",
      id: 0,
      provinceOptions: [],
      cityOptions: [],
      districtOptions: [],
    };
  },
  computed: {
    filteredForm() {
      Object.keys(this.form).forEach((key) => {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      });
      return this.form;
    },
    // 当前仓库+包裹预测重量+网点月结号
    expressLocationName() {
      const weightType = this.weightTypeOption.find((item) => {
        return this.sfForm.weight_type === item.key;
      });
      const weightTypeName = (weightType && weightType.name) || "";
      const monthlyId =
        (this.sfForm.cust_id && `【${this.sfForm.cust_id}】`) || "";
      const name = `${this.storehouse}${weightTypeName}${monthlyId}`;
      return name;
    },
  },
  methods: {
    handleDeleteSender(scope) {
      console.log("scope", scope);
      this.$confirm("是否删除该快递配置?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        postDelSender({ id: scope.row.id }).then(() => {
          this.$message.success("删除成功");
          if (this.tabActiveName === ADDRESS_SETTING) {
            this.fetchData();
          }
          if (this.tabActiveName === SF_EXPRESS_SETTING) {
            this.fetchSFData();
          }
        });
      });
    },
    handleAddSfExpress() {
      this.showEditSFForm = true;
    },
    handleAddJdExpress() {
      this.showEditJdForm = true;
    },
    /**
     * 多个同样预测重量范围的配置，至少有一个默认项，且仅有一个；
     * 若该预测重量范围已经存在"默认项"，提示：包裹预测重量已经存在默认选项
     */
    checkHasDefaultTips() {
      let hasDefault = false;
      if (this.sfForm.weight_type) {
        const list = this.resSFData.filter((item) => {
          return (
            item.weight_type === this.sfForm.weight_type &&
            this.sfForm.id !== item.id
          );
        });
        if (list.length) {
          hasDefault = list.some((item) => {
            return item.is_default === IS_DEFAULT_YES;
          });
        }
      }
      // 除已之外还有已设默认，且当前也选中默认选项，则显示提示，不拦截提交。
      this.showHasDefaultTips =
        hasDefault && this.sfForm.is_default === IS_DEFAULT_YES;
    },
    getStoreHouse() {
      this.storehouse = this.$cookie.get("storehouse_name");
    },
    // 获取当前使用的快递类型
    getExpressType() {
      warehouseConfigApi.getExpressType().then((res) => {
        const { list = [] } = res;
        this.expressTypeOption = list;
      });
    },
    handleSubmitSFForm() {
      this.$refs.sfForm.validate((valid) => {
        if (valid) {
          this.loadingSubmitSFForm = true;
          // 有id为编辑
          if (this.sfForm.sender_id) {
            warehouseConfigApi
              .editShippingSendSfConfig(this.sfForm)
              .then(() => {
                this.showEditSFForm = false;
                this.$message.success("操作成功");
                this.fetchSFData();
                this.handleResetSFForm();
              })
              .catch(this.$noop)
              .finally(() => {
                this.loadingSubmitSFForm = false;
              });
          } else {
            // 新增
            warehouseConfigApi
              .addShippingSendSfConfig(this.sfForm)
              .then(() => {
                this.showEditSFForm = false;
                this.$message.success("操作成功");
                this.fetchSFData();
                this.handleResetSFForm();
              })
              .catch(this.$noop)
              .finally(() => {
                this.loadingSubmitSFForm = false;
              });
          }
        }
      });
    },
    handleSubmitJdForm() {
      console.log(this.jdForm);
      this.$refs.jdForm.validate((valid) => {
        if (valid) {
          this.loadingSubmitJdForm = true;
          // 有id为编辑
          if (this.jdForm.sender_id) {
            warehouseConfigApi
              .editShippingSenderJdConfig(this.jdForm)
              .then(() => {
                this.showEditJdForm = false;
                this.$message.success("操作成功");
                this.featchJdData();
                this.handleResetJdForm();
              })
              .catch(this.$noop)
              .finally(() => {
                this.loadingSubmitJdForm = false;
              });
          } else {
            // 新增京东保价配置
            // 本次迭代略
          }
        }
      });
    },
    stateGuaranteeType(row, column) {
      if (row.guarantee_value === "1") {
        return "是";
      }
      return "否";
    },
    handleSubmitAccountCode() {
      if (!this.accountCode) {
        this.$message.error("顾客编码不能为空");
        return;
      }
      warehouseConfigApi
        .setAccountCustCode({
          sender_id: this.currentSenderId,
          cust_code: this.accountCode,
        })
        .then(() => {
          this.$message.success("修改成功");
          this.handleResetAccountCode();
        });
    },
    handleSubmitAccountToken() {
      if (!this.accountToken) {
        this.$message.error("校验码不能为空");
        return;
      }
      warehouseConfigApi
        .setAccountToken({
          sender_id: this.currentSenderId,
          account_token: this.accountToken,
        })
        .then(() => {
          this.$message.success("修改成功");
          this.handleResetAccountToken();
        });
    },
    handleResetSFForm() {
      this.$refs.sfForm.resetFields();
      this.sfForm = this.$options.data().sfForm;
    },
    handleResetJdForm() {
      this.$refs.jdForm.resetFields();
      this.jdForm = this.$options.data().jdForm;
    },
    handleResetAccountCode() {
      this.showAccountCode = false;
      this.accountCode = "";
      this.currentSenderId = "";
    },
    handleResetAccountToken() {
      this.showAccountToken = false;
      this.accountToken = "";
      this.currentSenderId = "";
    },
    // 显示弹框－账号编码
    showDialogAccountCode(row) {
      this.showAccountCode = true;
      this.currentSenderId = row.id;
    },
    // 显示弹框－校验码
    showDialogAccountToken(row) {
      this.showAccountToken = true;
      this.currentSenderId = row.id;
    },
    handleClickTab() {},
    setDefault(row) {
      this.$confirm("确认修改?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/erp/WavePicking/setDefaultSender", {
              id: row.id,
            })
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message.error(res.data.msg);
              } else {
                this.$message.success(res.data.msg);
                this.fetchData(true);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 设置是否开启预警通知
    setWarningSwitch(value, row) {
      const text =
        value === "1" ? "是否开启预警值通知？" : "是否关闭预警值通知？";
      this.$confirm(text, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.setWarningNotify({
            sender_id: row.id,
            is_warning: value,
            warning_num: row.warning_num,
          });
        })
        .catch(() => {
          // 取消时恢复开关值
          const index = this.resData.list.findIndex(
            (item) => item.id === row.id
          );
          const isWarning = row.is_warning === "1" ? "0" : "1";
          this.$set(this.resData.list, index, {
            ...row,
            is_warning: isWarning,
          });
        });
    },
    // 设置预警值
    setWarningNum(value, row) {
      this.setWarningNotify({
        sender_id: row.id,
        is_warning: row.is_warning,
        warning_num: value,
      });
    },
    // 设置预警信息
    setWarningNotify(params) {
      this.loading = true;
      this.$api
        .setWarningNotify(params)
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          } else {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.fetchData();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.origin = parseInt(res.data.data.origin, 10);
        }
      });
    },
    fetchSFData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      warehouseConfigApi
        .getShippingSendSfList(this.filteredForm)
        .then((res) => {
          const { list = [] } = res;
          // 类型转换 及 添加额外编辑状态字段
          const tempList = list.map((item) => {
            return {
              ...item,
              express_type: item.express_type && Number(item.express_type),
              isEditCustCode: false,
              cust_code: "",
              isEditAccountToken: false,
              account_token: "",
            };
          });
          this.loading = false;
          this.resSFData = tempList;
        });
    },
    featchJdData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      warehouseConfigApi.getShippingSenderJdList().then((res) => {
        const { list = [] } = res;
        // 类型转换 及 添加额外编辑状态字段
        const tempList = list.map((item) => {
          return {
            ...item,
          };
        });
        console.log("in fetch Jd");
        console.log(typeof tempList[0].guarantee_value);
        this.resJdData = tempList;
      });
      this.loading = false;
    },
    selectOrigin(id) {
      this.origin = id;
      this.form.origin = id;
      this.fetchData(true);
    },
    beforeSetSender(cpcode = "", id = 0, expressAccountId = "", reqFrom = 0) {
      let expressAccountIdTemp = expressAccountId;
      let cpcodeTemp = cpcode;
      if (cpcodeTemp === "") {
        cpcodeTemp = this.form.cpcode;
      }
      if (expressAccountIdTemp === "") {
        expressAccountIdTemp = this.form.express_account_id;
      }
      if (
        typeof cpcode === "undefined" ||
        typeof expressAccountIdTemp === "undefined"
      ) {
        return;
      }
      this.cpcode = cpcodeTemp;
      this.id = id;
      this.express_account_id = expressAccountIdTemp;
      this.$http
        .post("/erp/WavePicking/getSender", {
          cpcode: cpcodeTemp,
          sender_id: id,
          express_account_id: expressAccountIdTemp,
          req_from: reqFrom,
        })
        .then((res) => {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.senderVisible = true;
            this.senders = res.data.data.list;
            this.sender = res.data.data.cur_sender;
          }
        });
    },
    handleEditSFExpress(row) {
      this.sfForm = { ...row, sender_id: row.id };
      this.showEditSFForm = true;
      this.checkHasDefaultTips();
      this.getProvince();
    },
    handleEditJdExpress(row) {
      this.jdForm = { ...row, sender_id: row.id };
      this.showEditJdForm = true;
    },
    setSender() {
      this.$http
        .post("/erp/WavePicking/setSender", {
          cpcode: this.cpcode,
          sender: this.sender,
          express_account_id: this.express_account_id,
          id: this.id,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.$message.success(res.data.msg);
            this.senderVisible = false;
            this.shippingVisible = false;
            this.fetchData();
          }
        });
    },
    getProvince() {
      this.$http
        .post("/erp/Common/getProvince")
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error({
              message: res.data.msg,
              duration: 3000,
            });
            return;
          }
          this.provinceOptions = res.data?.data?.list || [];
          this.getCity();
        })
        .catch(this.$noop);
    },
    getCity(name) {
      if (name) {
        this.sfForm.city = "";
        this.sfForm.district = "";
      } else {
        name = this.sfForm.province;
      }
      const id = this.provinceOptions.find((item) => item.name === name)?.id;
      if (id > 0) {
        this.$http
          .post("/erp/Common/getCity", {
            province: id,
          })
          .then((res) => {
            if (res.data.code !== 200) {
              this.$message.error({
                message: res.data.msg,
                duration: 3000,
              });
              return;
            }
            this.cityOptions = res.data?.data?.list || [];
            this.getDistrict();
          })
          .catch(this.$noop);
      }
    },
    getDistrict(name) {
      if (name) {
        this.sfForm.district = "";
      } else {
        name = this.sfForm.city;
      }
      const id = this.cityOptions.find((item) => item.name === name)?.id;
      if (id > 0) {
        this.$http
          .post("/erp/Common/getDistrict", {
            city: id,
          })
          .then((res) => {
            if (res.data.code !== 200) {
              this.$message.error({
                message: res.data.msg,
                duration: 3000,
              });
              return;
            }
            this.districtOptions = res.data?.data?.list || [];
          })
          .catch(this.$noop);
      }
    },

    // 获取退换货默认快递显示文本
    getReturnDefaultText(row) {
      return row.exchange_default === "1" ? "是" : "否";
    },

    // 设置退换货默认快递
    setReturnDefault(row) {
      this.$confirm("是否修改该账号为退换货默认快递？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 调用接口设置退换货默认快递
          this.$http
            .post("/erp/WavePicking/setExchangeDefault", {
              id: row.id,
              exchange_default: row.exchange_default === "1" ? "2" : "1",
            })
            .then((res) => {
              if (res.data.code === 200) {
                this.$message.success("设置成功");
                this.fetchData(true);
              } else {
                this.$message.error(res.data.msg || "设置失败");
              }
            })
            .catch(() => {
              this.$message.error("设置失败");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/wavepicking/WavePickingSender.vue